import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import PropertyName from "csi/heading/PropertyName";
import Spec, { QuerySpec } from "csi/core/Spec";
import html from "csi/html";
import { getDomainClass } from "csi/reflection/reflection";
import { ATTR_PARENT, DUMMY } from "csi/typings";
import { pathCreate } from "csi/utility/pathUtility";
import { ViewTooltip } from "csi/view/Tooltip";
import declare from "dojo/_base/declare";

const ImageContainerContextRenderer = declare(PropertyName, {
	/** @property {boolean} renderTooltip - indicates if full name should be displayed in tooltip as well */
	renderTooltip: false,

	/**
	 * @override
	 * Cache up to two parents as direct parent may be a secondary class of a domain object
	 */
	addRendererDependencyPaths(h: Heading, paths: string[]): void {
		paths.push(pathCreate(ATTR_PARENT, ATTR_PARENT));
	},

	/**
	 * @override
	 * Do not allow filtering/sorting since renderer is changing context
	 */
	getQuerySpec(ctx: Context, h: Heading, spec: Spec): QuerySpec {
		return null;
	},

	/**
	 * @override
	 * Change context to parent domain object
	 */
	reserveContext(ctx: Context, h: Heading) {
		let node = ctx.getNodeParent();

		if (node && !getDomainClass(node.$Type)) {
			node = ctx.getNodeParent(node);
		}

		ctx.pushParams().setNodeURL(node?.$URL || DUMMY);
	},

	/**
	 * @override
	 * Change context back to original
	 */
	releaseContext(ctx: Context, h: Heading) {
		ctx.pop();
	},

	/**
	 * @override
	 * Add name in tooltip in case it overflows
	 */
	toTooltip: function (ctx: Context, h: Heading, tooltip: ViewTooltip): void {
		const multiLineText = this.toValue(ctx, h);
		if (multiLineText) {
			const element = html.create("div", { multiLineText });
			tooltip.addContent(element);
		}
	},
});

export = ImageContainerContextRenderer;
